import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
export default function LoginCheck() {
  const navigate = useNavigate();
  useEffect(() => {
    Logincheck();
  }, []);

  function Logincheck() {
    if (!Cookies.get("userinfo")) {
      return navigate("../Login");
    }


  }
}
